export function getErrorMsgForToast(response: any, t: (labelKey: string, defaultValue: string) => string) {
    const errorText = response.errors?.[0].errorInfo || t('Common.Toast.Error', 'An error occurred');
    const errorId = response.errors?.[0].message;
    if (!errorId) {
        return errorText;
    }
    return `${errorText} (Error-ID: ${errorId})`;
};
